import { ProjectContactFragmentFragment } from '@lopo-tech/lopo-api'
import React from 'react'
import { CLASS_PREFIX } from 'src/constants'
import { textResources } from 'src/lang/de'
import './project_contacts.scss'

const cls = `${CLASS_PREFIX}project-contacts`

const t = textResources.projects

type Props = {
  contacts: ProjectContactFragmentFragment[];
};

export const ProjectContacts: React.FC<Props> = ({ contacts }) => {
  if (contacts.length === 0) {
    return <p className={`${cls}__empty`}>{t.featureTabs.noContactInfo}</p>
  }

  return (
    <div className={cls}>
      {contacts.map((contact) => (
        <article className={`${cls}__card`} key={contact.id}>
          <div className={`${cls}__avatar`}>
            {contact.picture
              ? <img src={contact.picture.url} alt="" loading="lazy" />
              : <span className={`${cls}__avatar-fallback`}>{contact.name.charAt(0).toUpperCase()}</span>}
          </div>

          <div className={`${cls}__content`}>
            <div className={`${cls}__top`}>
              <div className={`${cls}__name`}>{contact.name}</div>

              {contact.description && (
                <div className={`${cls}__position`}>{contact.description}</div>
              )}
            </div>

            <div className={`${cls}__bottom`}>
              {contact.phone && (
                <div className={`${cls}__contact-row`}>
                  <span className={`${cls}__contact-label`}>{t.featureTabs.contactPhoneNumber}</span>
                  <a className={`${cls}__link`} href={`tel:${contact.phone}`}>
                    {contact.phone}
                  </a>
                </div>
              )}
              {contact.email && (
                <div className={`${cls}__contact-row`}>
                  <span className={`${cls}__contact-label`}>{t.featureTabs.contactEmail}</span>
                  <a className={`${cls}__link`} href={`mailto:${contact.email}`}>
                    {contact.email}
                  </a>
                </div>
              )}
            </div>
          </div>
        </article>
      ))}
    </div>
  )
}
